import React from 'react'
import freelancer from '../../../../assets/Services/freelancer.png'
import secure from '../../../../assets/Services/secure.png'
import support from '../../../../assets/Services/support.png'
import fees from '../../../../assets/Services/fees.png'
import marketplace from '../../../../assets/Services/marketplace.png'
import CTA from '../../../../components/cta/CTA'




export default function ServicesBottom() {
  const Data = [
    {
      logo: "./Assets/Service/service1.png",
      head: "Freelancer Marketplace",
      describe: "Dive into our diverse community of freelancers spanning various industries. From graphic design to programming to digital marketing, you'll find experts for every project. Our intuitive platform design makes it easy to find the perfect freelancer for your needs. And with our integrated security features, you can trust that your transactions are safe and protected.",
      img: freelancer
    },
    {
      logo: "./Assets/Service/service4.png",
      head: "Secure Buying and Selling",
      describe: "We understand the importance of feeling secure when trading online. That's why we've implemented robust security measures at Paycott to ensure your transactions are protected. From secure payment gateways to stringent verification procedures for sellers, we're committed to providing you with a safe trading environment.",
      img: secure
    },
    {
      logo: "./Assets/Service/service3.png",
      head: "Excellent Support",
      describe: "Your success is our priority. That's why we offer top-notch support to assist you with any questions or concerns. Our team of experienced customer service representatives is available around the clock to ensure that your experience with Paycott is smooth and satisfactory.",
      img: support
    },
    {
      logo: "./Assets/Service/service2.png",
      head: "Lowest Fees",
      describe: "At Paycott, we believe that trading should be accessible to all. That's why we only charge the lowest fees for our services. We want to ensure that both buyers and sellers can benefit from our services without being burdened by high fees.",
      img: fees
    },
    {
      logo: "./Assets/Service/service5.png",
      head: "Marketplace for Physical Goods",
      describe: "Explore a world of high-quality products from sellers around the globe. Whether you're in search of handcrafted jewelry, unique artworks, or trendy fashion items, you'll find it here. Our user-friendly platform allows you to discover and securely purchase your favorite products. And for sellers, we provide an easy way to showcase and sell your products to a wide audience.",
      img: marketplace
    },
  ]
  return (
    <div className="my-8 mx-auto items-center justify-center" id="services">
      {Data.slice(0, 2).map((item, index) => (
        <div key={index} className={`flex flex-col lg:flex-row ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-star my-8 mx-auto px-4 items-center justify-center`}>
          <div className="bg-white border p-6 border-gray-200 rounded-lg shadow-xl cursor-pointer ease-in-out duration-300 w-full md:w-2/5">
            <div className="flex flex-col gap-4 items-start">
              <div className="bg-gray-200 rounded-full p-4">
                <img src={item.logo} alt="" className="w-10 h-10 lg:w-12 lg:h-12" />
              </div>
              <h5 className="text-xl md:text-2xl font-semibold font-pop tracking-tight text-gray-900 dark:text-black">{item.head}</h5>
              <p className='text-base md:text-lg font-pop text-lightGrey md:leading-relaxed'>{item.describe}</p>
            </div>
          </div>
          <img src={item.img} alt="" className="w-full h-auto lg:h-auto md:w-2/5" />
        </div>
      ))}
      <CTA />
      {Data.slice(2).map((item, index) => (
        <div key={index} className={`flex flex-col lg:flex-row ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-star my-8 mx-auto px-4 items-center justify-center`}>
          <div className="bg-white border p-6 border-gray-200 rounded-lg shadow-xl cursor-pointer ease-in-out duration-300 w-full md:w-2/5">
            <div className="flex flex-col gap-4 items-start">
              <div className="bg-gray-200 rounded-full p-4">
                <img src={item.logo} alt="" className="w-10 h-10 lg:w-12 lg:h-12" />
              </div>
              <h5 className="text-xl md:text-2xl font-semibold font-pop tracking-tight text-gray-900 dark:text-black">{item.head}</h5>
              <p className='text-base md:text-lg font-pop text-lightGrey md:leading-relaxed'>{item.describe}</p>
            </div>
          </div>
          <img src={item.img} alt="" className="w-full h-auto lg:h-auto md:w-2/5" />
        </div>
      ))}
    </div>
  );
}
